/* eslint-disable import/prefer-default-export */
import axios from '../Axios'

const module = '/discounts'

export const getDiscountsByPartner = async (
  filtersDiscounts,
  page = 0,
  limit = 6
) => {
  const { id, order, archived = false } = filtersDiscounts
  const { data } = await axios.get(
    `${module}/?id=${id}&page=${page}&limit=${limit}&order=${order}&archived=${archived}`
  )
  return data
}

export const createNewDiscount = async (formData) => {
  const { data } = await axios.post(`${module}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return data
}

export const updateDiscount = async ({ userId, formData }) => {
  const { data } = await axios.patch(`${module}/${userId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return data
}

export const archiveDiscount = async ({ discountId, reason }) => {
  const { data } = await axios.patch(`${module}/${discountId}/archive`, {
    reason
  })
  return data
}

export const restoreDiscount = async (discountId) => {
  const { data } = await axios.patch(`${module}/${discountId}/restore`)
  return data
}
